import React from "react";
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import DestinationDetails from "./DestinationDetails";
import styles from "./index.module.css";
import { useTranslation } from "react-i18next";

const DestinationSection = ({
  handleClickNotes,
  destinationDetails,
  activeStep,
  handleMultiComplete,
  shifterType,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles["patient-transport__data-container-title"]}>
        <PiMapPinSimpleAreaBold color="#2C4861" size={24} />
        <label className={styles["patient-transport__data-label"]}>
          {t("Destination")}
        </label>
      </div>
      <DestinationDetails
        destinationDetails={destinationDetails}
        activeStep={activeStep}
        handleMultiComplete={handleMultiComplete}
        handleClickNotes={handleClickNotes}
        shifterType={shifterType}
      />
    </>
  );
};

export default DestinationSection;
